module.exports = __webpack_public_path__ + "static/img/8497_phase_function_Paper_Points.4909741.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8497_phase_function_Paper_Points.png
// module id = MwTI
// module chunks = 0